import { encodeId } from "../api/utils";

const ROUTES = {
  INDEX: "/",

  ATHLETE_PROFILE: "/athlete/profile/:id",
  GET_ATHLETE_PROFILE_URL: (id) => `/athlete/profile/${encodeId(id)}`,

  TEAM_PROFILE: "/team/profile/:id",
  GET_TEAM_PROFILE_URL: (id) => `/team/profile/${encodeId(id)}`,

  POST: "/posts/:id",
  GET_POST_URL: (id) => `/posts/${encodeId(id)}`,

  HIGHLIGHT: "/highlights/:id",
  GET_HIGHLIGHT_URL: (id) => `/highlights/${encodeId(id)}`,

  EVENT: "/events/:id",
  GET_EVENT_URL: (id) => `/events/${encodeId(id)}`,

  CHALLENGE: "/challenges/:id",
  GET_CHALLENGE_URL: (id) => `/challenges/${encodeId(id)}`,

  REACH_OUT: "/reach-out",
};

export default ROUTES;
